import React, { useState, useEffect } from 'react';
import { KeyValuePair } from 'helpers';
import axios from 'axios';
import { IOMSUser } from 'helpers/interfaces';
import ReferenceDataKey from 'helpers/enums/ReferenceDataKey';
import { OrderQueues } from 'helpers/enums';


interface IApplicationContext {
    isLoading: boolean
    referenceData: IReferenceData
    currentUser: IOMSUser
}

interface IReferenceData {
    [ReferenceDataKey.Warehouse]: KeyValuePair<string, string>[]
    [ReferenceDataKey.Country]: KeyValuePair<string, string>[]
    [ReferenceDataKey.DueCountry]: KeyValuePair<string, string>[]
    [ReferenceDataKey.Account]: KeyValuePair<string, string>[]
    [ReferenceDataKey.Locale]: KeyValuePair<string, string>[]
    [ReferenceDataKey.OrderStatus]: KeyValuePair<string, string>[]
    [ReferenceDataKey.Channel]: KeyValuePair<string, string>[]
    [ReferenceDataKey.OrderQueues]: KeyValuePair<OrderQueues, string>[]
    [ReferenceDataKey.DUESyncError]: KeyValuePair<string, string>[]
    [ReferenceDataKey.PaymentStatus]: KeyValuePair<string, string>[]
    [ReferenceDataKey.ChannelType]: KeyValuePair<string, string>[]
    [ReferenceDataKey.DocumentType]: KeyValuePair<string, string>[]
    [ReferenceDataKey.ERPVendorCodes]: KeyValuePair<string, string>[]
}

export let applicationContext = React.createContext({} as IApplicationContext);

let { Provider } = applicationContext;

let ApplicationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {

    let [isLoading, setLoading] = useState(true);
    let [currentLocale, setCurrentLocale] = useState('it-IT');
    let [currentUser, setCurrentUser] = useState({} as IOMSUser);
    let [referenceData, setReferenceData] = useState({} as IReferenceData);

    useEffect(() => {
        getReferenceData();
    }, []);

    let getReferenceData = async () => {
        try {
            setLoading(true);

            let res = await axios.get('/api/ReferenceData/GetReferenceDataValues');

            let { item } = res.data;
            setCurrentUser(item.currentUser);
            setReferenceData(item.referenceData);

            setLoading(false);
        } catch (err) { }
    }

    return (
        <Provider value={{
            isLoading,
            referenceData,
            currentUser
        }}>
            {children}
        </Provider>
    )
}

export default ApplicationProvider;